export default __webpack_public_path__ + "static/media/photo2.4f34d18d.jpeg";